/** Folder colours on offer (null = the neutral default). */
export const FOLDER_COLORS = ['#3262B5', '#0E9F6E', '#D97706', '#DC2626', '#7C3AED', '#DB2777', '#0891B2', '#64748B']
